import { DateTimeStr, toDateTimeStr } from '@mi-front/core';
import {
  PntSegmentsControllerGetLowerthirdByDate200,
  PntLowerthirdSegments,
  PntLowerthirdSegmentsResponse,
} from '@mi-front/api-v2';

/**
 * OpenAPI models a single segment union; the endpoint returns an array at runtime.
 */
function asLowerthirdItems(
  data:
    | PntSegmentsControllerGetLowerthirdByDate200
    | PntSegmentsControllerGetLowerthirdByDate200[]
    | null
    | undefined,
): Array<PntLowerthirdSegmentsResponse | PntLowerthirdSegments> {
  if (!data) {
    return [];
  }

  return (Array.isArray(data) ? data : [data]) as Array<
    PntLowerthirdSegmentsResponse | PntLowerthirdSegments
  >;
}

/**
 * Normalizes api-v2 lowerthird payloads into absolute `from`/`to` string ranges.
 */
export function normalizeLowerthirdByDateResponse(
  data:
    | PntSegmentsControllerGetLowerthirdByDate200
    | PntSegmentsControllerGetLowerthirdByDate200[]
    | null
    | undefined,
): Array<{ text: string; from: DateTimeStr; to: DateTimeStr }> {
  return asLowerthirdItems(data).map((item) => {
    if ('from' in item && 'to' in item) {
      return {
        text: item.text,
        from: item.from as DateTimeStr,
        to: item.to as DateTimeStr,
      };
    }

    return {
      text: item.text,
      from: toDateTimeStr(item.start),
      to: toDateTimeStr(item.end),
    };
  });
}
